'use client';

import { useEffect, useState } from 'react';
import { useToast } from '@/components/admin/Toast';
import type { PlanRow, TenantRow } from '../types';

export function PlansPanel({ tenants, onRefresh }: { tenants: TenantRow[]; onRefresh: () => void }) {
  const { toast } = useToast();
  const [plans, setPlans] = useState<PlanRow[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/super-admin/plans')
      .then((r) => r.json())
      .then((j) => setPlans(j.data ?? []))
      .finally(() => setLoading(false));
  }, []);

  const assignPlan = async (tenantId: string, plan_slug: string) => {
    const res = await fetch(`/api/super-admin/tenants/${tenantId}/plan`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ plan_slug }),
    });
    if (res.ok) {
      toast('Plano atualizado');
      onRefresh();
    } else {
      toast('Erro ao atualizar plano', 'error');
    }
  };

  if (loading) return <p className="text-sm text-ink-500">A carregar planos...</p>;

  return (
    <div className="space-y-6">
      <div className="sa-panel-grid sa-panel-grid-3">
        {plans.map((p) => (
          <div key={p.id} className="sa-kpi">
            <p className="sa-kpi-label">{p.name}</p>
            <p className="sa-kpi-value text-xl">€{Number(p.price).toFixed(0)}<span className="text-sm font-normal text-ink-500">/mes</span></p>
            <p className="sa-kpi-sub">{p.tenant_count} tenants · {p.slug}</p>
            <p className="text-xs text-ink-500 mt-2">{p.description}</p>
          </div>
        ))}
      </div>

      <section className="sa-card">
        <header className="sa-card-header">
          <h3 className="sa-card-title">Plano por tenant</h3>
        </header>
        <div className="sa-table-wrap">
          <table className="sa-table">
            <thead><tr><th>Tenant</th><th>Plano atual</th><th>Alterar</th></tr></thead>
            <tbody>
              {tenants.map((t) => (
                <tr key={t.id}>
                  <td>{t.name}</td>
                  <td><span className="sa-tag">{t.plan_slug ?? 'starter'}</span></td>
                  <td>
                    <select
                      className="input-field text-sm py-1"
                      value={t.plan_slug ?? 'starter'}
                      onChange={(e) => assignPlan(t.id, e.target.value)}
                    >
                      {plans.map((p) => (
                        <option key={p.slug} value={p.slug}>{p.name}</option>
                      ))}
                    </select>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </section>
    </div>
  );
}
